/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';
import { interviewAdhocAttendeeDtoSchema } from './interview-adhoc-attendee-dto';
import { interviewCandidateDtoSchema } from './interview-candidate-dto';
import { interviewContactDtoSchema } from './interview-contact-dto';

export const calendarEventInviteeDtoSchema = z.object({ "adhocAttendee": z.lazy(() => interviewAdhocAttendeeDtoSchema).nullish(), "attendeeResponse": z.enum(["Accepted", "Declined", "Pending", "Tentative"]).nullish(), "candidate": z.lazy(() => interviewCandidateDtoSchema).nullish(), "contact": z.lazy(() => interviewContactDtoSchema).nullish(), "id": z.string().uuid() });
export type CalendarEventInviteeDto = z.infer<typeof calendarEventInviteeDtoSchema>;
